import { aemApiGet, apiPost } from '../../api/api-configuration';
import {
  AEM_API_ARTICLE_CONTENT_ENDPOINT,
  AEM_API_INITIATE_ARTICLE_CONTENT,
  AEM_API_COMPLETE_ARTICLE_CONTENT,
  AEM_API_ERROR_ARTICLE_CONTENT,
  API_ARTICLES_ENDPOINT,
  API_ERROR_ARTICLES,
  API_COMPLETE_ARTICLE_DETAIL,
  RELATED_PRODUCTS_COUNT,
  RELATED_ARTICLES_COUNT,
  CLEAR_ARTICLE_CONTENT,
} from '../../app-constants';
import { trimArray, redirectToErrorPage } from '../../app-actions';

// Actions
// article section fetch from AEM
export const articleSectionSuccessAction = articlesData => ({ type: AEM_API_COMPLETE_ARTICLE_CONTENT, data: articlesData });

export const articleSectionFailureAction = (error) => {
  redirectToErrorPage();
  return { type: AEM_API_ERROR_ARTICLE_CONTENT, error };
};

export const getArticleContent = data => (dispatch) => {
  const endpoint = `${AEM_API_ARTICLE_CONTENT_ENDPOINT}${data.articleId}.content.htm`;
  dispatch({ type: AEM_API_INITIATE_ARTICLE_CONTENT });
  aemApiGet(dispatch, endpoint, articleSectionSuccessAction, articleSectionFailureAction);
};

export const clearArticleContent = () => (dispatch) => {
  const emptyArticleDetail = '<div></div>';
  dispatch({ type: CLEAR_ARTICLE_CONTENT, data: emptyArticleDetail });
};

// we can process related product text transformation in this function.
export const processArticleDetails = (articleDetail) => {
  const { relatedProducts = [], relatedArticles = [] } = articleDetail.data || {};
  // trim relatedProducts displayed to the pre-defined value
  const relatedProductsTrimmed = trimArray(relatedProducts, RELATED_PRODUCTS_COUNT);
  relatedProductsTrimmed.map((productItem) => {
    const text = productItem.referenceTag; // currently assigning referenceTag to text just for testing.
    return { text, ...productItem };
  });
  // trim relatedArticles displayed to the pre-defined value
  const relatedArticlesTrimmed = trimArray(relatedArticles, RELATED_ARTICLES_COUNT);
  return { ...articleDetail, relatedProducts: relatedProductsTrimmed, relatedArticles: relatedArticlesTrimmed };
};

export const articleSuccessAction = (articleDetail) => {
  const processedArticleDetails = processArticleDetails(articleDetail);
  return ({ type: API_COMPLETE_ARTICLE_DETAIL, data: processedArticleDetails });
};

export const articleFailureAction = (error) => {
  redirectToErrorPage();
  return { type: API_ERROR_ARTICLES, error };
};

export const getArticleDetail = data => (dispatch) => {
  apiPost(dispatch, API_ARTICLES_ENDPOINT, articleSuccessAction, articleFailureAction, data);
};
